export class SupplierWorktimeSettings {
    public worktimeRegistrationStart: string;
    public worktimeRegistrationEnd: string;
    public isWorktimeRegistrationEnabled: boolean;
}
